import { useRegistration } from '@quizzach/api-hooks';
import {
	registrationFields,
	RegistrationState,
	ApiFailedReason,
	RoutePath,
	IRegistrationFields,
} from '@quizzach/interfaces';
import { AuthField, BtnTeal, CkRow, RegFormEl } from '@quizzach/styles';
import { IcCheck } from '@quizzach/assets';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { InlineAlertMessage, AlertMessage } from '@quizzach/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const RegistrationForm = () => {
	const [checked, setChecked] = useState(false);
	const { t } = useTranslation();

	const {
		registrationState,
		registrationDisable,
		validationErrorStates,
		error,
		errorCode,
		isLoading,
		showPassword,
		buttonClicked,
		handleInputChange,
		handleSubmit,
		togglePasswordVisibility,
	} = useRegistration();

	const renderField = ({
		identifier,
		type,
		label,
		autoCapitalize,
	}: IRegistrationFields) => (
		<div key={identifier} className='registration-form-container'>
			<AuthField $hasEye={type === 'password'}>
				<input
					autoCapitalize={autoCapitalize.toString()}
					placeholder={t(label)}
					type={type === 'password' && showPassword ? 'text' : type}
					name={identifier}
					key={identifier}
					value={registrationState[identifier as keyof RegistrationState]}
					onChange={(event) =>
						handleInputChange(event.target.name, event.target.value)
					}
				/>
				{type === 'password' && (
					<span className='eye-icon' onClick={togglePasswordVisibility}>
						{showPassword ? <FaEye /> : <FaEyeSlash />}
					</span>
				)}
			</AuthField>

			{buttonClicked &&
				validationErrorStates[identifier as keyof RegistrationState] && (
					<InlineAlertMessage
						message={
							buttonClicked &&
							validationErrorStates[identifier as keyof RegistrationState]
								? validationErrorStates[identifier as keyof RegistrationState]
								: undefined
						}
						type='warning'
						className='validation-alert'
						$fixed
					/>
				)}
		</div>
	);

	return (
		<RegFormEl onSubmit={handleSubmit} noValidate>
			<div className='form-container'>
				<div className='frow'>
					{registrationFields.slice(0, 2).map(renderField)}
				</div>
				{registrationFields.slice(2).map(renderField)}
				<CkRow style={{ marginTop: '18px' }}>
					<input
						type='checkbox'
						checked={checked}
						onChange={() => setChecked(!checked)}
					/>
					<span className='box'>
						<IcCheck size={14} />
					</span>
					<p>
						{t('auth.registration.agreeWith')}{' '}
						<Link to={RoutePath.TermsOfUse}>
							{t('auth.registration.termsOfUse')}
						</Link>
					</p>
				</CkRow>
				{error && (
					<AlertMessage
						code={
							errorCode === 'email_in_use'
								? ApiFailedReason.emailInUse
								: ApiFailedReason.default
						}
						type='error'
						style={{ width: '100%', marginTop: '18px' }}
					/>
				)}
				<div style={{ marginTop: '26px' }}>
					<BtnTeal
						className='submit'
						type='submit'
						disabled={!registrationDisable || !checked}
					>
						{isLoading ? (
							<span className='loader'></span>
						) : (
							<span>{t('auth.registration.submit')}</span>
						)}
					</BtnTeal>
				</div>
			</div>
		</RegFormEl>
	);
};
